// extracted by mini-css-extract-plugin
module.exports =  {"root":"nfpF0KbFYNuUQSeWmAha"};